export default class DtoBoreholeCommentItem {
    constructor(obj) {
        this.installationId = obj.installationId
        this.order = obj.order
        this.depth = obj.depth
        this.comment = obj.comment
        this.headers = ['depth', 'comment']
    }
}